import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect } from "react";
const jobsData = [
  {
    title: "VR Developer",
    description: "Join our team to build cutting-edge VR experiences.",
    location: "Remote",
  },
  {
    title: "UI/UX Designer",
    description: "Design intuitive interfaces for immersive applications.",
    location: "San Francisco, CA",
  },
  {
    title: "Project Manager",
    description: "Lead our VR projects to success.",
    location: "New York, NY",
  },
];

function Careers() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          CAREERS
        </h2>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {jobsData.map((job, index) => (
            <div key={index} className="col">
              <div className="card h-100 bg-light shadow-sm">
                <div className="card-body">
                  <h3 className="fs-6 fw-light mb-3">{job.title}</h3>
                  <p className="text-secondary mb-2 line-height-relaxed">
                    {job.description}
                  </p>
                  <p className="text-secondary mb-0">
                    <strong>Location:</strong> {job.location}
                  </p>
                </div>
                <div className="card-footer bg-transparent border-0">
                  <button className="btn btn-dark w-100 text-uppercase">
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Careers;
